/*
 * Main entry point
 */

import analytics from './components/analytics.js';
import gallery from './components/gallery.js';
import home from './components/home.js';
import social from './components/social.js';
import story from './components/story.js';
import ui from './components/ui.js';
import utilities from './components/utilities.js';

/**
 * Initialize the app on DOM ready
 */
$(function() {
	analytics.init({
        addGA: false,
		addGTM: false,
	});
	gallery.init();
	home.init();
	social.init();
	story.init();
	ui.init();
	utilities.init();
});



// WEBPACK FOOTER //
// ./scripts/theme.js